import { uniqBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParty } from '../../../../../parties/src/features/detail/api/getParty';
import { useRiskObjectsByParty } from '../../../../../parties/src/features/risk-objects/api/getAllRiskObjectByParty';

const useRiskObjectsForPartyList = (partyId: string) => {
  const { t } = useTranslation();
  const { data: riskObjectData, ...otherProps } =
    useRiskObjectsByParty(partyId);
  const { data: partyData } = useParty(partyId);

  const options = Object.values(riskObjectData || {})
    .flat()
    .map(({ risk_object_id, name }) => ({
      label: name || '',
      value: risk_object_id,
    }));
  const managmentRisks =
    partyData?.managements
      ?.filter(({ name }) => !!name)
      .map(({ name }) => ({
        label: name,
        value: name,
      })) || [];

  const data = [...options, ...managmentRisks];
  const staffOption = { label: t('STAFF'), value: 'staff' };
  if (partyData?.type === 'COMPANY') data.push(staffOption);

  // Make Other option the last one
  data.push({ value: 'OTHER', label: t('OTHER') });

  return {
    data: uniqBy(data, 'value'),
    ...otherProps,
  };
};

export default useRiskObjectsForPartyList;
